<span [class]="cssClass()" [attr.title]="tooltip()" [attr.aria-label]="tooltip()">{{
  label()
}}</span>
